import React, {useEffect, useState} from 'react';
import Banner from "components/banner/banner";
import UseContext from "hooks/useContext";
import useFetchData from "../../../hooks/useFetchData";
import SectionWrapper, {FormField, inputClassName} from "../components/SectionWrapper";

const Contact = () => {
    const {userData} = useFetchData();
    const {data, setData} = UseContext()

    useEffect(() => {
        if (userData?.firstname && userData?.lastname) {
            if (data.contact_name !== undefined && data.contact_name !== null && data.contact_name === '') {
                setData(prevData => ({
                    ...prevData,
                    contact_name: userData?.firstname + ' ' + userData?.lastname
                }))
            }
            if (data.contact_poste !== undefined && data.contact_poste !== null && data.contact_poste === '') {
                setData(prevData => ({
                    ...prevData,
                    contact_poste: 'Responsable'
                }))
            }
        }
    }, [userData]);

    return (
        <SectionWrapper 
            title="Responsable de la mission" 
            description="Indiquez les informations du responsable en charge de l'intérimaire pour cette mission."
        >
            <FormField label="Nom complet du responsable">
                        <input
                    name="contact_name"
                            value={data.contact_name}
                            onChange={(e) => setData(prevData => ({
                                ...prevData,
                                contact_name: e.target.value
                            }))}
                    className={inputClassName}
                            type="text"
                            required
                        />
            </FormField>
            <FormField label="Fonction">
                        <input
                    name="contact_poste"
                            value={data.contact_poste}
                            onChange={(e) => setData(prevData => ({
                                ...prevData,
                                contact_poste: e.target.value
                            }))}
                    className={inputClassName}
                            type="text"
                            required
                        />
            </FormField>
        </SectionWrapper>
    );
};

export default Contact;
